import { $api } from '@service/RequestService';
import { timeStampToDate } from '@utils/index';
import { useInfiniteQuery } from 'react-query';

import { crmConstants, crmModels } from '..';

export const useLeadFilterV2 = ({ enabled, ...props }: any) =>
  useInfiniteQuery<crmModels.ILeadFilterV2>(
    [crmConstants.queryKeys.LEAD_FILTER_V2, props, enabled],
    async ({ pageParam = 1 }) => {
      const res = await $api.post('/v1/lead/filter/v2', {
        page: pageParam,
        size: 20,
        ...props,
        leadNotTask: props?.leadNotTask === 'true' ? true : undefined
      });

      const data: crmModels.ILeadFilterV2 = res?.data?.data;

      return {
        ...data,
        leadList: {
          ...data?.leadList,
          data: data?.leadList?.data?.map(lead => ({
            ...lead,
            createdDate: timeStampToDate({ date: lead?.createdDate, timeStamp: lead?.createdTimestamp }),
            updatedDate: timeStampToDate({
              date: lead?.updatedDate,
              timeStamp: lead?.updatedTimestamp,
              format: 'DD.MM.YYYY HH:mm:ss'
            }),
            taskFinishDate: timeStampToDate({
              date: lead?.taskFinishDate,
              timeStamp: lead?.taskFinishTimestamp
            })
          }))
        }
      };
    },
    {
      enabled,
      getNextPageParam: (lastPage, page) => {
        if (page.length < lastPage?.leadList?.totalPages) {
          return page.length + 1;
        }
        return undefined;
      },
      staleTime: 15000
    }
  );
